import { useQueries, useQuery, useSuspenseQuery } from '@tanstack/react-query'

import { getRequest } from 'src/lib/api-client'
import { queries } from 'src/lib/query-keys'
import type { PublicUserData } from 'src/shared/features/users/schemas/user'

export const getUserById = async (userId: number) => {
  try {
    const result = await getRequest<PublicUserData>(`/users/lookup?id=${userId}`)
    if (!result) {
      return null
    }
    return result
  } catch (error) {
    console.error('Error fetching user by ID:', error)
    return null
  }
}

export const useUserByIdSuspense = (userId: number) => {
  return useSuspenseQuery({
    ...queries.users.detailById(userId),
    queryFn: () => getUserById(userId),
    retry: false,
    staleTime: 5 * 60 * 1000,
  })
}

// TODO: Use this userId enabled check design pattern everywhere
export const useUserById = (userId: number) => {
  return useQuery({
    ...queries.users.detailById(userId),
    queryFn: () => getUserById(userId),
    retry: 1,
    staleTime: 5 * 60 * 1000,
    enabled: userId > -1,
  })
}

export const useUsersById = (userIds: number[] | Set<number>) => {
  const ids = Array.isArray(userIds) ? userIds : Array.from(userIds)
  const userQueries = useQueries({
    queries: ids.map((id) => ({
      ...queries.users.detailById(id),
      queryFn: () => getUserById(id),
      retry: 1,
      staleTime: 5 * 60 * 1000,
      enabled: id > -1,
    })),
  })

  return userQueries.map((queryResult, index) => {
    if (ids[index] <= -1) {
      return null
    }

    return queryResult.data ?? null
  })
}
